export default {"buttonScrollToTopSkin1Container":"BFCBc","btnBox":"zgdhe","scrollBtnIconBox":"zb4JV"};